export default __webpack_public_path__ + "static/media/defaultImage.81ae1c78.jpg";